import { render } from "./GeneratorAddons.vue?vue&type=template&id=b94563d2&scoped=true"
import script from "./GeneratorAddons.vue?vue&type=script&lang=js"
export * from "./GeneratorAddons.vue?vue&type=script&lang=js"

import "./GeneratorAddons.vue?vue&type=style&index=0&id=b94563d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b94563d2"]])

export default __exports__